import { action } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";

export interface OnUninstallM365AcquisitionActionMessage {
    hasAddin: boolean;
    appId: string | undefined;
    extensionId: string | undefined;
    mailboxInfo: MailboxInfo | undefined;
}
const onUninstallM365Acquisition: (hasAddin: boolean, appId: string | undefined, extensionId: string | undefined, mailboxInfo?: MailboxInfo) => OnUninstallM365AcquisitionActionMessage = action("onUninstallM365Acquisition", (hasAddin: boolean, appId: string | undefined, extensionId: string | undefined, mailboxInfo?: MailboxInfo): OnUninstallM365AcquisitionActionMessage => ({
    hasAddin,
    appId,
    extensionId,
    mailboxInfo,
}));

export default onUninstallM365Acquisition;
